<template>
  <article class="episode article">
    <router-link :to="{ name: 'Post', params: { slug: episode.slug } }" class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
    </router-link>
    <div class="content">
      <router-link :to="{ name: 'Post', params: { slug: episode.slug } }"><h2 v-html="episode.title"></h2></router-link>
      <p><span v-html="episode.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: episode.slug } }" class="more-link">More</router-link></p>
      <div class="playModule">
        <div class="playButton">
          <router-link :to="{ name: 'Post', params: { slug: episode.slug } }">
            <span v-if="episodeNumber">{{ episodeNumber }} &bull; </span>{{ formattedDate }}
          </router-link>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'episode-module',
  props: ['episode'],
  computed: {
    episodeNumber () {
      if (this.episode.lstplus) {
        return 'LST+'
      } else if (this.episode.number) {
        return 'Episode #' + this.episode.number
      }
    },
    formattedDate () {
      return this.$moment(this.episode.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.episode.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  }
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

$sectionColor: $turquoise

.episode
  padding: 32px 24px 85px
  background: white
  border-bottom: none
  position: relative
  margin-bottom: 34px
  +tablet
    width: 31.75%
  .image
    padding-bottom: 56.25%
    background: $sectionColor
    margin-bottom: 1.75rem
    background-size: cover
    background-position: center center
  .content
    h2
      font-size: 24px
      font-weight: bold
      &:hover
        color: lighten($textColor, 25%)
    .playModule
      padding: 0 24px
      position: absolute
      bottom: 24px
      left: 0
      right: 0
      &:after
        content: ''
        border-bottom: 8px solid $sectionColor
        position: absolute
        left: 0px
        right: 0px
        top: 50%
        transform: translateY(-25%)
      .playButton
        display: flex
        align-items: center
        width: 100%
        border: none
        background: $sectionColor
        text-align: left
        font-size: 16px
        padding: 1rem 1.5rem
        color: $textColor
        position: relative
        line-height: 1.2
        z-index: 1
        +desktop
          font-size: 20px
        a
          color: inherit
          &:hover
            text-decoration: underline
        .icon
          width: 34px
          height: 34px
          background: white
          border-radius: 50%
          margin-right: 1rem
          .fa
            font-size: 18px
            position: relative
            left: 2px
</style>



// WEBPACK FOOTER //
// EpisodeModule.vue?1647ec10